import { getNowAsStr } from '.'

export const getRowKey = (prefix: string, index: number) => {
  return `${prefix}-${index}`
}

export const getColumnKey = (
  prefix: string,
  rowIndex: number,
  columnIndex: number
) => {
  return `${getRowKey(prefix, rowIndex)}-${columnIndex}`
}

export const getComponentId = (prefix: string) => {
  return prefix + '-' + getNowAsStr()
}

export const getElementId = () => {
  return getComponentId('element')
}
